import { ReactComponent as Icon } from "./home.svg";

const HomeIcon = () => {
    return <Icon />;
}

export default HomeIcon;